import { render, staticRenderFns } from "./DetailFolderOther.vue?vue&type=template&id=5ea007e5&scoped=true"
import script from "./DetailFolderOther.vue?vue&type=script&lang=js"
export * from "./DetailFolderOther.vue?vue&type=script&lang=js"
import style0 from "./DetailFolderOther.vue?vue&type=style&index=0&id=5ea007e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea007e5",
  null
  
)

export default component.exports